import { STRINGS } from '@/strings/strings';
import type { PdfStatus, StoryAudioStatus } from '@/features/story/types';

interface Props {
  audioStatus: StoryAudioStatus;
  pdfStatus: PdfStatus;
}

/**
 * Single at-top banner when any asset failed. Copy adapts to whether
 * only audio, only PDF, or both failed. Hidden entirely when both
 * assets are in healthy states (any non-failed).
 *
 * `not_requested` is NOT a failure — it's an explicit user opt-out,
 * so it doesn't trigger the banner. Only `failed` counts.
 */
export function StoryAssetFailureBanner({ audioStatus, pdfStatus }: Props) {
  const audioFailed = audioStatus === 'failed';
  const pdfFailed = pdfStatus === 'failed';
  if (!audioFailed && !pdfFailed) return null;

  const copy = STRINGS.storyOutput.page.failureBanner;
  const text = audioFailed && pdfFailed ? copy.both : audioFailed ? copy.audioOnly : copy.pdfOnly;

  return (
    <div
      role="status"
      className="rounded-lg border border-dream-gold/40 bg-dream-gold/12 px-4 py-3 text-sm leading-relaxed text-warning-text"
    >
      {text}
    </div>
  );
}
